export const PRODUCT_CARD_ARROW_SRC = 'https://acko-cms.ackoassets.com/Product_Card_Arrow_e95ee90d10.svg'
export const MODAL_CROSS_ICON = 'https://acko-cms.ackoassets.com/Homepage_Modal_Cross_Icon_5d8b7213a4.svg'
export const ACKO_APP_QR_CODE = 'https://acko-cms.ackoassets.com/Acko_app_QR_code_cf5289f9dd.webp'
